import { TipoPrestacion } from "./tipoPrestacion.model"

export class Prestacion {

  id: number
  asociado: number
  tipo: TipoPrestacion
  transaccion: number
  fecha_generacion: string
  fecha_pago: string
  iban: string
  importe_bruto: number
  irpf: number
  retencion: number
  importe_neto: number
  anulada: string

  descripcion: string
  titular: string
  dni: string

  anyo: number
  bruto: string
  concepto: string
  total: string
  devolucion: string

  constructor() {
    this.id = 0
    this.asociado = 0
    this.tipo = new TipoPrestacion()
    this.transaccion = 0
    this.fecha_generacion = ''
    this.fecha_pago = ''
    this.iban = ''
    this.importe_bruto = 0
    this.irpf = 0
    this.retencion = 0
    this.importe_neto = 0
    this.descripcion = ''
    this.titular = ''
    this.dni = ''

    this.anyo = 0
    this.concepto = ''
    this.bruto = ''
    this.total = ''
    this.anulada = 'N'

    this.devolucion = ''

  }

}
